import {useQuery} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {useClientV2} from "../../../../utils/hooks";
import {GET_CUSTOMER_PURCHASED_SUBSCRIPTION_RQ_KEY} from "../constants";
import {normalizeCustomerPurchasedSubscriptionDetail} from "./normalize";
import type {CustomerPurchasedSubscriptionDetail} from "./types";

export const useGetCustomerPurchasedSubscription = (subscriptionId?: number) => {
  const client = useClientV2();

  return useQuery<
    CustomerPurchasedSubscriptionDetail,
    AxiosError<{status: boolean; message: string}>
  >({
    queryKey: [GET_CUSTOMER_PURCHASED_SUBSCRIPTION_RQ_KEY, String(subscriptionId)],
    queryFn: async () => {
      if (!subscriptionId) {
        throw new Error("Subscription not found");
      }
      const raw = await client(`customer/subscriptions/${subscriptionId}`);
      const detail = normalizeCustomerPurchasedSubscriptionDetail(raw);
      if (!detail) {
        throw new Error("Subscription not found");
      }
      return detail;
    },
    enabled: !!subscriptionId,
    staleTime: 60_000,
  });
};
